export default "__VITE_ASSET__DYkCrVll__"